import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  id: string;
  title: string;
  children: ReactNode;
  className?: string;
}
export function Section({
  id,
  title,
  children,
  className = ''
}: SectionProps) {
  return <motion.section id={id} className={`py-20 px-4 md:px-8 max-w-7xl mx-auto ${className}`} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} data-id="element-166">
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-167">
        {title}
      </h2>
      {children}
    </motion.section>;
}